import React, { useEffect, useState } from "react";
import { Layout, Space, Table, PageHeader, Select, Button, message, Avatar, Row, Col, Tabs, Divider, Input, Grid } from "antd";
import { useHistory, useRouteMatch, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import {ArrowsAltOutlined,ShrinkOutlined
} from "@ant-design/icons";

const { useBreakpoint } = Grid;


const SectionList = ({sectionItems=[],i,sectionDataItem,updateSection,setShowExpanded,showExpanded,dataItem, isFromAddPopup,addedTables,selectedTable }) => {

    const history = useHistory();
    const [section, setSections] = useState([])
    const [sectionData, setSectionData] = useState([])
    const adminRestaurant = useSelector((state) => state.admin)
     const screens = useBreakpoint();

    useEffect(() => {
        setSections(sectionItems)
        setSectionData(sectionDataItem)
    }, [sectionItems,sectionDataItem])

const addTableSelection = (item)=>{
  addedTables(item)
}
const lastColSpan = sectionData.length % 2 ===1 ?24 :12;

    return (
        <Col
        
        span={i === sectionData.length -1 ? lastColSpan : screens.md ? 12:24} key={i}
        className="table-section"
        style={{
          fontWeight: 400,
          fontSize: "20px",
          backgroundColor:showExpanded?dataItem?.bg: ["#FFE4E4", "#DBFFFB", "#FFFAD2", "#F4E2FF"][
            i % 4
          ],
          color:showExpanded?dataItem?.color: ["#E12552", "#2543E1", "#E16925", "#E12596"][i % 4],
        }}
        // onDragOver={(e) => e.preventDefault()}
        // onDrop={() => sectionDrop(i)}
      >
        <div className="section-title-collapse"><div> Section {showExpanded?dataItem?.number+1:i+1} </div>
        {!isFromAddPopup &&
        <>
        {showExpanded?
        <ShrinkOutlined className="expand-icon" onClick={()=>setShowExpanded(false,section,
          ["#FFE4E4", "#DBFFFB", "#FFFAD2", "#F4E2FF"][
            i % 4
          ],["#E12552", "#2543E1", "#E16925", "#E12596"][i % 4],i)}/>:
        <ArrowsAltOutlined className="expand-icon" onClick={()=>setShowExpanded(true,section,
          ["#FFE4E4", "#DBFFFB", "#FFFAD2", "#F4E2FF"][
            i % 4
          ],["#E12552", "#2543E1", "#E16925", "#E12596"][i % 4],i)} />}
          </>
        }
        
        </div>
       
        <Row
        style={{
          margin: "1rem",
          marginLeft: 0,
          lineHeight: "2rem",
          textAlign: "center",
          fontSize: "15px",
          minHeight:"100px"
        }}
      
       
      >
        {section.map((item, j) => (
          item &&
          <Col
          
          
            className="table-type"
            style={{ marginLeft: ".5rem", marginBottom: ".5rem",border:`1px solid ${item.color}`,
                 paddingRight: `${item.paddingRight}`  }}
          >
            <div className={selectedTable?.length>0 && selectedTable.some(items => items.table_number === item?.table_number)?"section-input selection-table":"section-input"} onClick={()=> isFromAddPopup? addTableSelection(item) :updateSection(item,section,dataItem)}>
              <div>
              {` ${item.table_number}`}
              </div>
              {showExpanded &&
              <div>{item.text} Top</div>}
            </div>
            
          </Col>
        ))}
      </Row>
      </Col>
    );
};

export default SectionList;
